import { render, staticRenderFns } from "./ContainerWidgetSummary.vue?vue&type=template&id=3cd45c5e&scoped=true"
import script from "./ContainerWidgetSummary.vue?vue&type=script&lang=js"
export * from "./ContainerWidgetSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd45c5e",
  null
  
)

export default component.exports